"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBLabel = require("./HBLabel.styles");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBLabel = function HBLabel(_ref) {
  var id = _ref.id,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    className = _ref.className,
    text = _ref.text,
    isRequired = _ref.isRequired,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "".concat(_colors["default"].neutral900) : _ref$color,
    _ref$uppercase = _ref.uppercase,
    uppercase = _ref$uppercase === void 0 ? false : _ref$uppercase,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'normal' : _ref$fontWeight;
  var label = typeof text === 'string' ? "".concat(text, " ").concat(isRequired ? '*' : '') : text;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'label',
    componentName: 'HBLabel'
  });
  return /*#__PURE__*/_react["default"].createElement(_HBLabel.Label, {
    htmlFor: id,
    size: size,
    disabled: disabled,
    className: className,
    color: color,
    fontWeight: fontWeight,
    uppercase: uppercase,
    "data-testid": finalTestId
  }, label);
};
var _default = exports["default"] = HBLabel;
//# sourceMappingURL=HBLabel.js.map